import { BaseService, Service } from "/@/cool";
@Service("messageNotifyRecord")
class MessageNotifyRecord extends BaseService {}
export default MessageNotifyRecord;
